(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["air-reviews-theme"] && !Shopify.designMode) return;
  try {
    (() => {
    const labelsElement = document.getElementById('SisReviewsLabels');
    if (!labelsElement || document.documentElement.dataset.sisReviewsModalReady === 'true') return;

    document.documentElement.dataset.sisReviewsModalReady = 'true';

    let labels;
    try {
      labels = JSON.parse(labelsElement.textContent);
    } catch {
      return;
    }

    let dialog;
    let dialogBody;
    let activeList;
    let activePlaceholder;
    let activeParent;
    let activeNextSibling;
    let returnFocus;
    let syncQueued = false;

    const getReviewList = (root) => Array.from(root.querySelectorAll('.AirReviews-Blocks__List')).find((list) =>
      list.querySelector(':scope > .AirReviews-Blocks__ListReview > .AirReviews-Blocks__ReviewDetails')
    );

    const ensureDialog = () => {
      if (dialog) return dialog;

      dialog = document.createElement('dialog');
      dialog.className = 'sis-reviews-dialog';
      dialog.setAttribute('aria-labelledby', 'SisReviewsDialogTitle');

      const header = document.createElement('header');
      header.className = 'sis-reviews-dialog__header';

      const title = document.createElement('h2');
      title.className = 'sis-reviews-dialog__title';
      title.id = 'SisReviewsDialogTitle';
      title.textContent = labels.allReviews;

      const closeButton = document.createElement('button');
      closeButton.className = 'sis-reviews-dialog__close';
      closeButton.type = 'button';
      closeButton.setAttribute('aria-label', labels.close);
      closeButton.textContent = '×';

      dialogBody = document.createElement('div');
      dialogBody.className = 'sis-reviews-dialog__body AirReviews-Widget__V2';

      header.append(title, closeButton);
      dialog.append(header, dialogBody);
      document.body.append(dialog);

      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (activeList) {
          activeList.classList.remove('sis-reviews-list--modal');
          if (activePlaceholder && activePlaceholder.isConnected) {
            activePlaceholder.replaceWith(activeList);
          } else if (activeParent) {
            const reference = activeNextSibling && activeNextSibling.parentNode === activeParent ? activeNextSibling : null;
            activeParent.insertBefore(activeList, reference);
          }
        }

        document.body.classList.remove('sis-reviews-modal-open');
        activeList = undefined;
        activePlaceholder = undefined;
        activeParent = undefined;
        activeNextSibling = undefined;

        const focusTarget = returnFocus;
        returnFocus = undefined;
        scheduleSync();
        if (focusTarget && focusTarget.isConnected) focusTarget.focus();
      });

      return dialog;
    };

    const openReviews = (list, trigger) => {
      if (activeList) return;

      ensureDialog();
      returnFocus = trigger;
      activeList = list;
      activeParent = list.parentNode;
      activeNextSibling = list.nextSibling;
      activePlaceholder = document.createElement('div');
      activePlaceholder.className = 'sis-reviews-list-placeholder';
      activePlaceholder.style.height = `${Math.ceil(list.getBoundingClientRect().height)}px`;
      list.before(activePlaceholder);
      list.classList.add('sis-reviews-list--modal');
      dialogBody.append(list);
      document.body.classList.add('sis-reviews-modal-open');
      dialog.showModal();
      dialog.querySelector('.sis-reviews-dialog__close').focus();
    };

    const syncRoot = (root) => {
      const list = getReviewList(root);
      if (!list || list === activeList) return;

      const reviewGroup = list.querySelector(':scope > .AirReviews-Blocks__ListReview');
      const reviews = reviewGroup ? Array.from(reviewGroup.children).filter((card) =>
        card.classList.contains('AirReviews-Blocks__ReviewDetails')
      ) : [];

      document.querySelectorAll('[data-sis-open-reviews]').forEach(trigger => { trigger.hidden = false; });
      list.classList.add('sis-reviews-main-list');
      reviews.forEach((review, index) => review.classList.toggle('sis-review-card--extra', index >= 3));

      const summary = root.querySelector('.AirReviews-Blocks__SummaryInner');
      if (summary) list.style.setProperty('--sis-reviews-summary-height', `${Math.ceil(summary.getBoundingClientRect().height)}px`);

      let button = list.querySelector(':scope > .sis-reviews-view-more');
      if (reviews.length > 3) {
        if (!button) {
          button = document.createElement('button');
          button.className = 'sis-reviews-view-more';
          button.type = 'button';
          button.textContent = labels.viewMore;
          button.addEventListener('click', () => openReviews(list, button));
          list.append(button);
        }
      } else if (button) {
        button.remove();
      }
    };

    const syncReviews = () => {
      if (!activeList) document.querySelectorAll('.AirReviews-Widget__V2').forEach(syncRoot);
      syncQueued = false;
    };

    const scheduleSync = () => {
      if (syncQueued) return;
      syncQueued = true;
      requestAnimationFrame(syncReviews);
    };

    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-sis-open-reviews]');
      if (!trigger) return;
      const root = Array.from(document.querySelectorAll('.AirReviews-Widget__V2')).find(item => getReviewList(item));
      const list = root && getReviewList(root);
      if (list) openReviews(list, trigger);
    });

    const start = () => {
      scheduleSync();
      const observer = new MutationObserver(scheduleSync);
      observer.observe(document.body, { childList: true, subtree: true });
      window.addEventListener('resize', scheduleSync, { passive: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
